module.exports = __webpack_public_path__ + "img/cloud-computing.299584ca.svg";